module.exports = __webpack_public_path__ + "static/media/pickup-change-notification.1d34d3fe.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/components/home/sounds/pickup-change-notification.mp3
// module id = 13748
// module chunks = 0